export const Facebook = ({ className }: { className: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_11327_122"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21"
      >
        <path d="M20 0.453125H0V20.4531H20V0.453125Z" fill="white" />
      </mask>
      <g mask="url(#mask0_11327_122)">
        <path
          d="M20 10.4531C20 4.93027 15.5229 0.453125 10 0.453125C4.47715 0.453125 0 4.93027 0 10.4531C0 15.4443 3.65684 19.5814 8.4375 20.3316V13.3437H5.89844V10.4531H8.4375V8.25C8.4375 5.74375 9.93047 4.35938 12.2146 4.35938C13.3084 4.35938 14.4531 4.55469 14.4531 4.55469V7.01562H13.1922C11.95 7.01562 11.5625 7.78652 11.5625 8.57812V10.4531H14.3359L13.8926 13.3437H11.5625V20.3316C16.3432 19.5814 20 15.4443 20 10.4531Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
